<template lang="pug">
span
  v-menu(v-model="showMenu" rounded="lg" :close-on-content-click="false" offset-y max-height="420" min-width="320" max-width="320" nudge-bottom="8")
    template(v-slot:activator="{ on, attrs }")
      div(v-on="on")
        y-button(:label="getButtonText" outlined color="neutral400" background-color="var(--v-neutral100)" text-color="neutral700" prepend-icon="$yzi-filter-line" icon-color="neutral500" icon-size="16" unset-min-width size="xxs" height="24" button-class="px-2")
    
    .white
      .menu-header.white
        .font-semibold.text-sm.pa-4 Filter diagnoses
        v-text-field.text-sm.round-xl.mx-4.mb-3(v-model="searchText" @input="queryChanged" outlined :placeholder="$t('search')" dense hide-details)
        v-divider

      v-skeleton-loader.pa-4(v-if="isLoading" type="text@3")
      div(v-else)
        template(v-if="diagnoses.length > 0")
          div(v-for="diagnosis in diagnoses" :key="diagnosis.value")
            .d-flex.text-sm.px-4.py-3.cursor-pointer.hover-bg(@click="clickItem(diagnosis)")
              yc-checkbox(:input-value="isChecked(diagnosis.value)" @change="clickItem(diagnosis)")
              .ml-4 {{ diagnosis.label }}
            v-divider.basic300
        template(v-else)
          .text-center.py-8.text-xs.neutral500--text No diagnoses found
          
    .bottom-0.sticky.z-1.white
      .d-flex.align-center.px-4.py-2.border-t
        y-button(v-if="!noSelectedDiagnoses" label="Reset" underline size="xs" button-class="px-0" unset-min-width @click="resetData")
        v-spacer
        y-button(:label="$t('apply')" size="xs" button-class="px-2" @click="apply")
</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'

export default {
  data: () => ({
    showMenu: false,
    isLoading: true,
    searchText: '',
    diagnoses: [],
    selectedDiagnoses: [],
    checkedDiagnoses: [],
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      visitFilters: 'treatment/getVisitFilters',
    }),
    noSelectedDiagnoses () {
      return this.checkedDiagnoses.length === 0
    },
    getButtonText () {
      let text = 'All diagnoses'
      if (this.selectedDiagnoses.length > 1) {
        text = `${this.selectedDiagnoses.length} diagnoses selected`
      } else if (this.selectedDiagnoses.length === 1) {
        text = this.selectedDiagnoses[0].label
      }
      return text
    },
  },
  watch: {
    showMenu (value) {
      if (value) {
        this.setData()
      }
    }
  },
  mounted () {
    this.fetchDiagnoses()
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      if (this.visitFilters.diagnoses) {
        this.checkedDiagnoses = JSON.parse(JSON.stringify(this.visitFilters.diagnoses))
        this.selectedDiagnoses = JSON.parse(JSON.stringify(this.visitFilters.diagnoses))
      } else {
        this.checkedDiagnoses = []
        this.selectedDiagnoses = []
      }
    },
    fetchDiagnoses () {
      this.isLoading = true
      const params = {
        company: this.company.id,
        enabled: true,
        field: 'consultation.diagnosis',
        search: this.searchText || ''
      }
      this.$axios.get(`/options`, { params })
      .then(resp => {
        this.diagnoses = resp.data.results.map(item => {
          return {
            label: item.value,
            value: `${item.id}`
          }
        })
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    resetData () {
      this.checkedDiagnoses = []
      this.apply()
    },
    apply () {
      let obj = { diagnoses: this.checkedDiagnoses }
      this.$store.commit('treatment/updateVisitFilters', obj)
      this.selectedDiagnoses = this.checkedDiagnoses
      this.$emit('change')
      this.showMenu = false
    },
    clickItem (item) {
      if (this.checkedDiagnoses.map(i => i.value).includes(item.value)) {
        this.checkedDiagnoses = this.checkedDiagnoses.filter(x => x.value !== item.value)
      } else {
        this.checkedDiagnoses.push(item)
      }
    },
    queryChanged: debounce(function () {
      this.fetchDiagnoses()
    }, 750),
    isChecked (value) {
      return this.checkedDiagnoses.filter(item => item.value === value).length > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}
.menu-header {
  top: 0;
  position: sticky;
  z-index: 1;
}
</style>